<template>
  <div>
    <choose-component-transform-or-link :items='types'
                                        @next='$emit("next")'
                                        :enable-categories='true'
                                        :categories='categories'
                                        :sort-keys='categorySorting'
                                        @select='onSelect' />
  </div>
</template>
<script>

import ChooseComponentTransformOrLink from '@ui/molecules/ChooseComponentTransformOrLink.vue';
import * as ComponentsDb from '@edit/tree/componentsdb.js';
import * as IconMapping from '@components/iconMapping.js';
export default {
  props: {
    toys:{
      type: Array,
      default() {
        return [];
      }
    },
    onlyShowToys: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const categories = ComponentsDb.categories;
    const categorySorting = {
      'Create': '0',
      'Change': '1'
    }
    return {
      selectedType: '',
      categories,
      categorySorting
    }
  },
  components:{
    ChooseComponentTransformOrLink
  },
  methods: {
    onSelect(type) {
      this.$emit('add', {
        type
      });
    },
  },
  computed: {
    types() {
      const types = this.onlyShowToys ? [] : Object.values(ComponentsDb.types).filter( (type) => {
        return type.toplevel && !type.hidden;
      }).map( (type) => {
        const icon = IconMapping.default[type.type];
        let category = type.category;
        if (!category) {
          category = ComponentsDb.categories.misc;
        } else {
          category = category;
        }

        return {
          icon,
          category,
          ...type
        }
      });

      return this.toys.map( ({name,description,toy,thumbnailImage}) => {
        if (!thumbnailImage || thumbnailImage === '') {
          thumbnailImage = 'placeholder.png';
        }
        const category = ComponentsDb.categories.toys;
        const icon = IconMapping.default.tween;
        return {
          description,
          text:name,
          icon,
          type:toy,
          category,
          image:thumbnailImage
        }
      }).concat(types);

    }
  }
}
</script>
